import {getDynamoItemElement} from '@packages/systems/dynamo/utils/DynamoElementUtils';
import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, type Qualified} from '@packages/systems/wfdl-Qualified';

import {type ExpressionElement} from '@packages/systems/wfdl-ast';

export const boundaryElementType: Qualified<Component.ComponentName> = qualify(
  Plugins.name('Dynamo'),
  Component.name('DynamoWrapper')
);

export const createBindingContextBoundary = (
  element: ExpressionElement
): Readonly<{
  boundaryType: 'startAt';
  boundaryElementId: string;
  boundaryContextVariant: 'List';
}> | null => {
  const dynamoItemId = getDynamoItemElement(element)?.id;

  if (!dynamoItemId) {
    // corrupt node structure, so we can't really do much
    return null;
  }

  return {
    boundaryType: 'startAt',
    boundaryElementId: dynamoItemId,
    boundaryContextVariant: 'List',
  };
};
